module.exports = __webpack_public_path__ + "static/01_No-Tax-compressed-c9028f7bbdf67d5fcdc16c2978aee4bf.png";